<template>
  <div class="cascader relative">
    <el-cascader
      class="w-3/4"
      v-model="issue.value"
      :options="issue.groups"
      :props="prop"
      :placeholder="issue.placeholder"
      :clearable="question.required"
      popper-class="linkage-popper"
      filterable
    />
    <div v-if="issue.levelsNum < issue.requiredNum" class="mt-2">
      <el-input v-for="item in issue.items" :key="item.id" v-model="item.value" placeholder="详细地址" />
    </div>
    <div v-if="view" class="absolute inset-0 z-50"></div>
    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems"/>
      <template v-if="voteItems.length > 5">
        <el-button class="w-full" @click="onShowMoreRank">查看更多排名</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import voteMixin from './vote'
export default {
  name: 'Cascader',
  changeExpr: 'issue.value',
  mixins:[voteMixin],
  data() {
    return {
      prop: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'content',
        children: 'nextLevelOptions'
      }
    }
  }
}
</script>
